import { useTranslation } from "react-i18next";
import { Asterisk } from "lucide-react";

export const PhotoRequirements = () => {
  const { t } = useTranslation();
  
  return (
    <div className="flex-1 space-y-2 text-sm text-muted-foreground">
      <div className="font-medium text-foreground mb-2">
        {t('onboarding.photoRequirements')}
      </div>
      <div className="flex items-center gap-2">
        <Asterisk className="h-3 w-3 text-red-500" />
        <span>{t('onboarding.photoRequirement1')}</span>
      </div>
      <div className="flex items-center gap-2">
        <Asterisk className="h-3 w-3 text-red-500" />
        <span>{t('onboarding.photoRequirement2')}</span>
      </div>
      <div className="flex items-center gap-2">
        <Asterisk className="h-3 w-3 text-red-500" />
        <span>{t('onboarding.photoRequirement3')}</span>
      </div>
    </div>
  );
};